<template>
  <router-view />
</template>

<script>
// test
//import ComponentInWorker from "@/components/ComponentInWorker";
export default {
  name: "trainingMview"
  // components: {
  //   ComponentInWorker
  // }
};
</script>

<style></style>
